const cardItems = [
  {
    title: '新手必读：漫画阅读入门指南',
    desc: '刚接触漫画？这篇指南帮你快速了解韩漫、日漫、国漫的区别与特色，找到最适合你的阅读方向。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20comic%20books%20and%20manga%20arranged%20on%20a%20wooden%20desk%20with%20warm%20lamp%20light%2C%20cozy%20reading%20atmosphere%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20aesthetic&width=600&height=400&seq=cards-beginner-01&orientation=landscape',
    tag: '入门',
  },
  {
    title: '2026年最值得追的韩漫Top20',
    desc: '编辑团队严选20部当前最热韩漫，从宫廷恋爱到都市悬疑，每一部都值得加入你的追更清单。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20top%20ranking%20list%20visual%20with%20colorful%20cover%20art%20collage%2C%20warm%20golden%20lighting%2C%20cream%20background%2C%20editorial%20composition%2C%20clean%20style&width=600&height=400&seq=cards-kr-top-02&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '日漫经典作品全本资源汇总',
    desc: '鬼灭之刃、进击的巨人、咒术回战等经典日漫全本完整版，一份清单帮你找到所有神作。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20classic%20collection%20with%20iconic%20cover%20art%20displayed%2C%20warm%20ambient%20lighting%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20composition&width=600&height=400&seq=cards-jp-classic-03&orientation=landscape',
    tag: '经典',
  },
  {
    title: '国漫玄幻类作品深度解析',
    desc: '从斗破苍穹到完美世界，国产玄幻漫画凭什么圈粉无数？深度解析国漫的独特魅力与进步。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20genre%20analysis%20visual%20with%20ink%20wash%20style%20illustration%2C%20warm%20earth%20tones%2C%20cream%20background%2C%20elegant%20editorial%20composition&width=600&height=400&seq=cards-cn-fantasy-04&orientation=landscape',
    tag: '分析',
  },
  {
    title: '下拉式阅读 vs 翻页式：哪种更适合你？',
    desc: '两种主流漫画阅读方式的全方位对比，帮你选择最适合自己阅读习惯的打开方式。',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20and%20physical%20book%20side%20by%20side%20showing%20comic%20reading%20comparison%2C%20warm%20lighting%2C%20cream%20background%2C%20clean%20editorial%20photography&width=600&height=400&seq=cards-reading-05&orientation=landscape',
    tag: '指南',
  },
  {
    title: '漫画收藏管理小技巧',
    desc: '教你如何高效管理阅读进度和收藏列表，让亲亲漫画成为你的专属漫画图书馆。',
    img: 'https://readdy.ai/api/search-image?query=Organized%20bookshelf%20with%20colorful%20comic%20collections%20neatly%20arranged%2C%20warm%20cozy%20lighting%2C%20cream%20background%2C%20editorial%20photography%2C%20clean%20aesthetic&width=600&height=400&seq=cards-collection-06&orientation=landscape',
    tag: '技巧',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-article-line text-sm"></i>
              漫画资讯
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              漫画资讯
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              漫画推荐、阅读指南和平台资讯，让你的漫画之旅更加丰富多彩
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {cardItems.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className="group flex flex-col sm:flex-row lg:flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="w-full sm:w-[180px] lg:w-full aspect-[16/10] sm:aspect-auto lg:aspect-[16/10] overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 md:p-5">
                  <span className="inline-block text-[10px] font-semibold text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full mb-2.5">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}